let map = {
    0: '待处理',
    1: '仓库接单',
    2: '挂起中',
    3: '处理中',
    4: '待审核',
    5: '部分审核',
    6: '已审核',
    7: '已推送第三方',
    10: '审核撤销',
    255: '单据关闭'
}

export const EntryOrderStatus = {
    ToBeProcessed: 0,
    Accepted: 1,
    Suspend: 2,
    Processing: 3,
    ToBeReviewed: 4,
    PartReviewed: 5,
    Reviewed: 6,
    Pushed: 7,
    Revoke: 10,
    Closed: 255
}

const getDescribe = (status) => {
    return map[status] || ('未知状态: ' + status)
}

const getOptions = (scene) => {
    scene = scene * 1
    let onlyStatusList = []
    if (scene === 12) {
        onlyStatusList = [4, 5, 6, 7, 10, 255]
    }
    const options = []
    for(let key in map) {
        const option = {
            label: map[key],
            value: key
        }
        if (onlyStatusList && onlyStatusList.length) {
            if (onlyStatusList.indexOf(key * 1) > -1) {
                options.push(option)
            }
        } else {
            options.push(option)
        }
    }
    return options
}

export default {
    getDescribe,
    getOptions,
}



// WEBPACK FOOTER //
// ./src/utils/newSys/entryOrderStatus.js